import { ArrowRight } from "lucide-react";
import { useNavigate } from "react-router-dom";
import "./FashionPromoBanner.css";

const FashionPromoBanner = () => {
    const navigate = useNavigate();

    const handleExploreFashion = () => {
        navigate("/Categories/Fashion");
    };

    return (
        <section className="fashion-promo">
            <div className="fashion-promo-container">
                <div className="fashion-promo-banner">
                    <img
                        src="/assets/images/banner/fashion-banner.jpg"
                        alt="Salar premium fashion collection"
                    />
                    <div className="fashion-promo-overlay" />
                    <div className="fashion-promo-content">
                        <span className="fashion-promo-kicker">SALAR FASHION</span>
                        <h2>
                            Discover your
                            <span>signature style.</span>
                        </h2>
                        <p>
                            Explore statement fashion, modern essentials and premium collections curated for every occasion.
                        </p>
                        <button
                            type="button"
                            className="fashion-promo-action"
                            onClick={handleExploreFashion}
                        >
                            Explore Fashion
                            <ArrowRight size={16} strokeWidth={1.9} />
                        </button>
                    </div>
                    <div className="fashion-promo-meta">
                        <span>New Season</span>
                        <span>Premium Edit</span>
                        <span>Trending Now</span>
                    </div>
                </div>
            </div>
        </section>
    );
};

export default FashionPromoBanner;